/* eslint-disable no-nested-ternary */
/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
/* eslint-disable no-console */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { v4 } from 'uuid'

// Images
import checkWhite from 'img/check_white.svg'
import calendarWhite from 'img/calendar_white.svg'
import handshakeWhite from 'img/handshake_white.svg'

// Components
import { Paragraph } from 'components/StyledComponents'
import Content from 'components/Content'

// CSS
import './GravityForm.css'

// Third Party
import _ from 'lodash'
import Select from 'react-select'
import styled, { css } from 'styled-components'
import parse from 'html-react-parser'

// Utilities
import { console } from 'globalthis/implementation'
import { chunkArray, getAddress, calculateColumn } from '../../utils'

const StyledColumn = styled.div`
  ${(props) =>
    props.columns === 'col-8' &&
    css`
      padding-right: 7.5px;
    `}

  ${(props) =>
    props.columns === 'col-4' &&
    css`
      padding-left: 7.5px;
    `}
  ${(props) =>
    props.columns === 'col-12' &&
    css`
      padding-left: 7.5px;
      padding-right: 7.5px;
    `}

  ${(props) =>
    props.columns === 'col-lg-6' &&
    css`
      padding-left: 7.5px;
      padding-right: 7.5px;
    `}
`

const WaardeContentBlock = styled.div`
  position: relative;
  border: 1px solid ${(props) => props.theme.color.main};
  padding: 45px 20px 35px 20px;

  p {
    line-height: 20px;
    text-align: center;
    font-size: 14px;
  }
`

const WaardeContent = styled.div`
  background-color: ${(props) => props.theme.color.light};
  padding: 50px 40px 50px 40px;

  ${WaardeContentBlock} + ${WaardeContentBlock} {
    margin: 50px 0 0 0;
  }

  @media screen and (max-width: 991px) {
    padding: 20px 20px 20px 20px;
  }
`

const WaardeContentIcon = styled.div`
  position: absolute;
  top: -32px;
  right: 0;
  left: 0;
  height: 64px;
  width: 64px;
  margin-right: auto;
  margin-left: auto;
  border-radius: 100px;
  background-color: ${(props) => props.theme.color.main};
  display: flex;
  justify-content: center;
  align-items: center;
`

const GravityForm = ({
  onComplete,
  waarde,
  service,
  currentObject,
  woningen,
  bedankt,
  redButton,
  greenButton,
  smallButton,
  id,
  perColumn,
  buttonText,
}) => {
  const {
    allGfForm: { edges: gravityData },
  } = useStaticQuery(graphql`
    query {
      allGfForm {
        edges {
          node {
            formId
            slug
            apiURL
            descriptionPlacement
            formFields {
              id
              label
              labelPlacement
              description
              descriptionPlacement
              type
              choices
              content
              errorMessage
              inputMaskValue
              isRequired
              visibility
              cssClass
              placeholder
              size
              defaultValue
              maxLength
            }
            button {
              text
            }
            confirmations {
              message
            }
          }
        }
      }
    }
  `)

  const { node: gfForm } = gravityData.filter(
    ({ node }) => node.formId === id
  )[0]

  const [fields, setFields] = useState({
    input_1: woningen && currentObject ? parse(currentObject.title) : '',
    input_8: service || '',
  })
  const [form, setForm] = useState(gfForm)
  const [status, setStatus] = useState('')
  const [message, setMessage] = useState('')
  const [zipcodeError, setZipcodeError] = useState(null)

  useEffect(() => {
    let tempForm = form

    // add submit button as a field
    if (
      tempForm.formFields.filter((item) => item.type === 'submit').length === 0
    ) {
      tempForm.formFields = [
        ...tempForm.formFields,
        {
          formId: v4(),
          type: 'submit',
          text: tempForm.button.text,
        },
      ]
    }

    if (perColumn) {
      tempForm = {
        ...tempForm,
        formFields: chunkArray(tempForm.formFields, perColumn),
      }
    }

    setForm({
      ...form,
      ...tempForm,
    })
  }, [])

  async function handleOnSubmit(event) {
    event.preventDefault()

    if (status === 'processing') {
      return
    }

    setStatus('processing')

    try {
      const formData = new FormData()

      for (const [key, value] of Object.entries(fields)) {
        formData.append(key, value)
      }

      const request = await fetch(`${form.apiURL}/submissions`, {
        method: 'POST',
        body: formData,
      })

      const response = await request.json()
      if (response.is_valid === true) {
        setStatus('done')
        // onComplete(true);
        setMessage(response.confirmation_message)
      } else {
        setStatus('error')
        console.log(response)
      }
    } catch (error) {
      setStatus('error')
      console.error(error)
    }
  }

  async function handleFieldChange(event, isFile) {
    // eslint-disable-next-line prefer-destructuring

    let { value } = event.target || event.value

    let address = false

    if (waarde && event.target.id === 'input_4') {
      const number = ''
      const name = event.target.id

      const zipcode = event.target.value.replace(/ /g, '')

      if (zipcode.length >= 6) {
        const regex = /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i
        const {
          response: { docs: results },
        } = await getAddress(zipcode, number)

        if (results && results.length !== 0 && regex.test(zipcode)) {
          address = results[0]
          setFields({
            ...fields,
            [name]: zipcode,
            input_7: address.straatnaam,
            input_8: address.woonplaatsnaam,
          })
          setZipcodeError(null)
        } else {
          address = { empty: true }
          setFields({
            ...fields,
            [name]: value,
          })
          setZipcodeError('Geen geldige postcode')
        }
      }
    }

    if (event.target) {
      if (event.target.type === 'checkbox') {
        value = event.target.checked ? event.target.value : ''
      }

      if (isFile) {
        // eslint-disable-next-line prefer-destructuring
        value = event.target.value
      }

      if (!address) {
        setFields({
          ...fields,
          [event.target.name]: value,
        })
      }
    } else if (!address) {
      setFields({
        ...fields,
        [event.name]: event.value,
      })
    }
  }

  if (status === 'done') {
    if (waarde) {
      return (
        <WaardeContent>
          <WaardeContentBlock>
            <div className="postion-relative">
              <WaardeContentIcon>
                <img src={checkWhite} alt="" />
              </WaardeContentIcon>
            </div>
            <p className="mb-0">
              We hebben je aanvraag ontvangen en zullen deze zo snel mogelijk in
              behandeling nemen.
            </p>
          </WaardeContentBlock>
          <WaardeContentBlock>
            <WaardeContentIcon>
              <img src={calendarWhite} alt="" />
            </WaardeContentIcon>
            <p className="mb-0">
              We proberen (op werkdagen) binnen 24 uur contact op te nemen om
              een afspraak met je in te plannen.
            </p>
          </WaardeContentBlock>
          <WaardeContentBlock>
            <WaardeContentIcon>
              <img src={handshakeWhite} alt="" />
            </WaardeContentIcon>
            <p className="mb-0">
              De makelaar komt graag bij je langs. Dit zal ca. 45 minuten duren.
            </p>
          </WaardeContentBlock>
        </WaardeContent>
      )
    }
    return <Content className="form-submission-message" content={message} />
  }

  if (form.formFields) {
    return (
      <form
        method="post"
        id={`form_${form.formId}`}
        className={`form form_${form.formId}`}
        onSubmit={handleOnSubmit}
      >
        {bedankt ? (
          <>
            <Paragraph className="font-weight-xl font-size-xm">
              Bedankt voor het contact opnemen, wij nemen zo snel mogelijk
              contact met u op!
            </Paragraph>
          </>
        ) : (
          <>
            {status === 'processing' && <Loading />}
            <div className="row">
              {form.formFields &&
                form.formFields.map((field, key) => {
                  if (Array.isArray(field)) {
                    return (
                      <div
                        key={key}
                        className={`col-lg-${calculateColumn(
                          form.formFields.length
                        )}`}
                      >
                        {field.map((item, index) => (
                          <FormField
                            service={service}
                            currentObject={currentObject}
                            woningen={woningen}
                            redButton={redButton}
                            smallButton={smallButton}
                            greenButton={greenButton}
                            key={index}
                            field={item}
                            fields={fields}
                            onChange={handleFieldChange}
                          />
                        ))}
                      </div>
                    )
                  }

                  let col = 'col-lg-12'
                  let needFields = false

                  if (field.type === 'checkbox') {
                    col = 'col-lg-6'
                  }
                  if (field.cssClass) {
                    if (
                      field.cssClass === 'ignore1' ||
                      field.cssClass === 'ignore2'
                    ) {
                      col = ''
                      needFields = true
                    } else {
                      col = field.cssClass
                      needFields = true
                    }
                  }

                  return (
                    <StyledColumn columns={col} key={key} className={col}>
                      <FormField
                        zipcodeError={zipcodeError}
                        needFields={needFields}
                        service={service}
                        currentObject={currentObject}
                        woningen={woningen}
                        redButton={redButton}
                        smallButton={smallButton}
                        greenButton={greenButton}
                        key={key}
                        field={field}
                        buttonText={buttonText}
                        fields={fields}
                        onChange={handleFieldChange}
                      />
                    </StyledColumn>
                  )
                })}
            </div>
          </>
        )}
      </form>
    )
  }

  console.error('No gravity forms found with id', id)
  return false
}

const Input = styled.input`
  width: 100%;
  padding: 10px 10px;
  outline: none;
  border: none;
  border-radius: 0;

  ::placeholder {
    font-size: ${(props) => props.theme.font.size.sm}px;

    ${(props) =>
    props.redButton
      ? `
      color: ${props.theme.color.main};
    `
      : (props) =>
        props.greenButton
          ? `
      color: ${props.theme.color.main};
    `
          : `
      color: ${props.theme.color.secondary};
    `}
  }
`

const TextArea = styled.textarea`
  width: 100%;
  padding: 10px 10px;
  outline: none;
  border: none;
  border-radius: 0px;
  min-height: 166px;

  ::placeholder {
    font-size: ${(props) => props.theme.font.size.ms};

    ${(props) =>
    props.redButton
      ? `
      color: ${props.theme.color.main};
    `
      : (props) =>
        props.greenButton
          ? `
      color: ${props.theme.color.main};
    `
          : `
      color: ${props.theme.color.secondary};
    `}
  }
`

const TextFieldWrapper = styled.div`
  position: relative;
  ${(props) =>
    props.textOnly &&
    css`
      font-size: 14px;
    `}

  ${(props) =>
    props.textOnly === 'ignore1' &&
    css`
      padding-left: 30px;
    `}
`

const ZipcodeError = styled.p`
  position: absolute;
  height: 100%;
  right: 15px;
  top: 8px;
  color: red;
  font-size: 12px;
`

const TextField = ({
  zipcodeError,
  fields,
  redButton,
  greenButton,
  value,
  onChange,
  field: { id, type, label, labelPlacement, placeholder, isRequired, cssClass },
}) => (
  <>
    {cssClass === 'ignore1' || cssClass === 'ignore2' ? (
      <TextFieldWrapper textOnly={cssClass} className="form-group">
        {cssClass === 'ignore2' ? (
          <>{value ? `, ${value}` : `, ${label}`}</>
        ) : (
          <>{value ? `${value} ${fields.input_6 || ``}` : label}</>
        )}
      </TextFieldWrapper>
    ) : (
      <TextFieldWrapper className="form-group">
        {labelPlacement !== 'hidden_label' && (
          <label htmlFor={`input_${id}`}>{label}</label>
        )}
        {cssClass === 'col-8' && zipcodeError && (
          <ZipcodeError className="mb-0">{zipcodeError}</ZipcodeError>
        )}
        <Input
          redButton={redButton}
          greenButton={greenButton}
          value={value}
          onChange={onChange}
          type="text"
          id={`input_${id}`}
          className={`${type}`}
          name={`input_${id}`}
          required={isRequired}
          placeholder={placeholder}
        />
      </TextFieldWrapper>
    )}
  </>
)

const NumberWrapper = styled.div``

const NumberField = ({
  redButton,
  value,
  onChange,
  field: { id, type, label, labelPlacement, placeholder, isRequired, cssClass },
}) => (
  <NumberWrapper className="form-group">
    {labelPlacement !== 'hidden_label' && (
      <label htmlFor={`input_${id}`}>{label}</label>
    )}
    <Input
      redButton={redButton}
      value={value}
      onChange={onChange}
      type="number"
      id={`input_${id}`}
      className={`${type} ${cssClass !== undefined ? cssClass : ''}`}
      name={`input_${id}`}
      required={isRequired}
      placeholder={placeholder}
    />
  </NumberWrapper>
)

const EmailFieldWrapper = styled.div``

const EmailField = ({
  redButton,
  greenButton,
  value,
  onChange,
  field: { id, type, label, labelPlacement, placeholder, isRequired, cssClass },
}) => (
  <EmailFieldWrapper className="form-group">
    {labelPlacement !== 'hidden_label' && (
      <label htmlFor={`input_${id}`}>{label}</label>
    )}
    <Input
      redButton={redButton}
      greenButton={greenButton}
      value={value}
      onChange={onChange}
      type="email"
      id={`input_${id}`}
      className={`${type}`}
      name={`input_${id}`}
      required={isRequired}
      placeholder={placeholder}
    />
  </EmailFieldWrapper>
)

const PhoneFieldWrapper = styled.div``

const PhoneField = ({
  redButton,
  greenButton,
  value,
  onChange,
  field: { id, type, label, labelPlacement, placeholder, isRequired, cssClass },
}) => (
  <PhoneFieldWrapper className="form-group">
    {labelPlacement !== 'hidden_label' && (
      <label htmlFor={`input_${id}`}>{label}</label>
    )}
    <Input
      redButton={redButton}
      greenButton={greenButton}
      value={value}
      onChange={onChange}
      type="tel"
      id={`input_${id}`}
      className={`${type}`}
      name={`input_${id}`}
      required={isRequired}
      placeholder={placeholder}
    />
  </PhoneFieldWrapper>
)

const TextAreaWrapper = styled.div``

const TextAreaField = ({
  redButton,
  greenButton,
  value,
  onChange,
  field: { id, type, label, labelPlacement, placeholder, isRequired, cssClass },
}) => (
  <TextAreaWrapper className="form-group">
    {labelPlacement !== 'hidden_label' && (
      <label htmlFor={`input_${id}`}>{label}</label>
    )}
    <TextArea
      redButton={redButton}
      greenButton={greenButton}
      value={value}
      onChange={onChange}
      id={`input_${id}`}
      className={`${type} ${cssClass !== undefined ? cssClass : ''}`}
      name={`input_${id}`}
      required={isRequired}
      placeholder={placeholder}
    />
  </TextAreaWrapper>
)

const CheckBoxWrapper = styled.div``

const CheckBox = styled.input``

const CheckBoxLabel = styled.label`
  color: ${(props) => props.theme.color.main} !important;
`

const CheckboxField = ({
  value,
  onChange,
  field: { label, id, type, cssClass, choices },
}) => {
  const list = JSON.parse(choices)

  return (
    <CheckBoxWrapper className="form-group">
      <Paragraph className="font-weight-xl">{label}</Paragraph>
      {list.map((checkbox, key) => (
        <div key={key} className="form-group__checkboxes">
          <CheckBox
            checked={value}
            onChange={onChange}
            type="checkbox"
            id={`input_${id}_${key + 1}`}
            className={`${type} ${cssClass !== undefined ? cssClass : ''}`}
            name={`input_${id}_${key + 1}`}
            value={checkbox.value}
          />
          <CheckBoxLabel
            htmlFor={`input_${id}_${key + 1}`}
            className="checkbox-content"
          >
            {checkbox.text}
          </CheckBoxLabel>
        </div>
      ))}
    </CheckBoxWrapper>
  )
}

const StyledSelect = styled(Select)`
  .react-select__control {
    border-radius: 0;
    border: none;
    height: 44px;
  }

  .react-select__value-container {
    padding: 0px 10px;
  }

  .react-select__single-value {
    margin-left: 0;
    margin-right: 0;
    color: ${(props) => props.theme.color.main};
    font-size: 16px;
  }

  .react-select__placeholder {
    color: ${(props) => props.theme.color.main};
    font-size: 14px;
  }
`

// Select or Dropdown
const SelectField = ({
  service,
  currentObject,
  woningen,
  field,
  onChange,
  value,
}) => {
  // Populate a options array
  const options = []

  if (field.cssClass === 'woningen' && woningen) {
    _.each(woningen, (woning) => {
      options.push({
        value: parse(woning.node.title),
        label: parse(woning.node.title),
        type: 'select',
        name: `input_${field.id}`,
      })
    })

    // Override value parameter
    value = parse(currentObject.title)
  } else if (service) {
    _.each(JSON.parse(field.choices), (choice) => {
      options.push({
        value: choice.value,
        label: choice.text,
        type: 'select',
        name: `input_${field.id}`,
      })
    })

    value = parse(service)
  } else {
    _.each(JSON.parse(field.choices), (choice) => {
      options.push({
        value: choice.value,
        label: choice.text,
        type: 'select',
        name: `input_${field.id}`,
      })
    })
  }

  // Custom Select component
  const MySelect = (props) => (
    <StyledSelect
      {...props}
      onChange={props.onChange}
      options={props.options}
      placeholder={props.placeholder}
    />
  )

  return (
    <div className="form-select mb-3">
      <MySelect
        options={options}
        onChange={onChange}
        value={options.filter((option) => option.value === value)}
        placeholder={field.label}
        classNamePrefix="react-select"
        className={`react-select-container ${field.cssClass === 'woningen' && woningen && 'd-none'
          }`}
      />
    </div>
  )
}

const SubmitButtonWrapper = styled.div`
  transition: 0.25s;

  :hover {
    transform: scale(1.05);
  }

  @media (max-width: 991px) {
    .button {
      width: 100% !important;
    }
  }

  ${(props) =>
    props.zipcodeError &&
    css`
      pointer-events: none;
      opacity: 0.3;
    `}
`

const Button = styled.button`
 display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: $font-size-m;
  font-weight: normal;
  line-height: 26px;
  padding: 8px 24px;
  border-radius: 59px;
  vertical-align: top;
  transition: all 0.3s;
  border: 2px solid transparent;
`

const SubmitButton = ({
  zipcodeError,
  redButton,
  greenButton,
  smallButton,
  buttonText,
  field,
}) => (
  <SubmitButtonWrapper
    zipcodeError={zipcodeError}
    className="d-flex justify-content-center"
  >
    <Button
      className={`button form-submit ${smallButton ? `w-50` : `w-100`} h-100 ${redButton
        ? `color-background-striking`
        : greenButton
          ? `color-background-green`
          : `color-background-main`
        }`}
      type="submit"
    >
      <Paragraph
        className="color-text-light font-size-18 font-weight-xl  text-uppercase"
      >
        {buttonText || field.text}
      </Paragraph>
    </Button>
  </SubmitButtonWrapper>
)

const FileInputWrapper = styled.div``

const FileField = ({
  onChange,
  field: { id, type, label, allowedExtensions, cssClass, placeholder },
}) => {
  function handleChange(file) {
    onChange(
      {
        target: {
          name: `input_${id}`,
          value: file,
        },
      },
      true
    )
  }

  function handleFileUpload(e) {
    const {
      target: { files },
    } = e

    for (let i = 0; i < files.length; i += 1) {
      handleChange(files[i])
    }
  }

  function handleFileDrop(e) {
    e.preventDefault()

    if (e.dataTransfer.items) {
      // Use DataTransferItemList interface to access the file(s)
      for (let i = 0; i < e.dataTransfer.items.length; i += 1) {
        // If dropped items aren't files, reject them
        if (e.dataTransfer.items[i].kind === 'file') {
          handleChange(e.dataTransfer.items[i].getAsFile())
        }
      }
    } else {
      // Use DataTransfer interface to access the file(s)
      for (let i = 0; i < e.dataTransfer.files.length; i += 1) {
        handleChange(e.dataTransfer.files[i])
      }
    }
  }

  return (
    <FileInputWrapper
      className="form-upload pb-3"
      onDrop={handleFileDrop}
      onDragOver={(e) => e.preventDefault()}
    >
      <label className="font-weight-xl" htmlFor={`input_${id}`}>
        {cssClass !== 'hidden-input-label' && <>{label}</>}
      </label>
      <input
        type="file"
        onChange={handleFileUpload}
        id={`input_${id}`}
        className={`${type} ${cssClass !== undefined ? cssClass : ''}`}
        name={`input_${id}`}
        placeholder={placeholder}
        accept={allowedExtensions}
      />
    </FileInputWrapper>
  )
}

export const FormField = ({
  zipcodeError,
  needFields,
  service,
  currentObject,
  woningen,
  redButton,
  greenButton,
  buttonText,
  smallButton,
  field,
  fields,
  onChange,
}) => (
  <>
    {field.type === 'text' && (
      <TextField
        zipcodeError={zipcodeError}
        fields={needFields && fields}
        redButton={redButton}
        greenButton={greenButton}
        onChange={onChange}
        value={fields[`input_${field.id}`]}
        field={field}
      />
    )}
    {field.type === 'email' && (
      <EmailField
        redButton={redButton}
        greenButton={greenButton}
        onChange={onChange}
        value={fields[`input_${field.id}`]}
        field={field}
      />
    )}
    {field.type === 'phone' && (
      <PhoneField
        redButton={redButton}
        greenButton={greenButton}
        onChange={onChange}
        value={fields[`input_${field.id}`]}
        field={field}
      />
    )}
    {field.type === 'textarea' && (
      <TextAreaField
        redButton={redButton}
        greenButton={greenButton}
        onChange={onChange}
        value={fields[`input_${field.id}`]}
        field={field}
      />
    )}
    {field.type === 'checkbox' && (
      <CheckboxField
        onChange={onChange}
        greenButton={greenButton}
        value={fields[`input_${field.id}`]}
        field={field}
      />
    )}
    {field.type === 'select' && (
      <SelectField
        onChange={onChange}
        greenButton={greenButton}
        service={service}
        currentObject={currentObject}
        woningen={woningen}
        value={fields[`input_${field.id}`]}
        field={field}
      />
    )}
    {field.type === 'fileupload' && (
      <FileField
        onChange={onChange}
        value={fields[`input_${field.id}`]}
        field={field}
      />
    )}
    {field.type === 'submit' && (
      <SubmitButton
        zipcodeError={zipcodeError}
        buttonText={buttonText}
        redButton={redButton}
        greenButton={greenButton}
        smallButton={smallButton}
        field={field}
      />
    )}
    {field.type === 'number' && (
      <NumberField
        redButton={redButton}
        greenButton={greenButton}
        onChange={onChange}
        value={fields[`input_${field.id}`]}
        field={field}
      />
    )}
  </>
)

export const Loading = () => (
  <div className="form-loading">
    <div className="form-loading-spinner">
      <div className="sk-chase">
        <div className="sk-chase-dot" />
        <div className="sk-chase-dot" />
        <div className="sk-chase-dot" />
        <div className="sk-chase-dot" />
        <div className="sk-chase-dot" />
        <div className="sk-chase-dot" />
      </div>
    </div>
  </div>
)

export default GravityForm
